import { LoanApiService } from './../../services/loan-api.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map, share } from 'rxjs/operators';

@Injectable()
export class LoanResolverService implements Resolve<any> {
  public loans: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public loanId: number;

  constructor(private loanApiService: LoanApiService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    const paramLoanId = +route.paramMap.get('loanId');
    return this.getLoan(paramLoanId).pipe(
      map((data: any) => {
        return {
          valueChanges: this.loans.asObservable(),
          refresh: (): Observable<any> => {
            const seq = this.getLoanDetails().pipe(share());
            seq.subscribe();
            return seq;
          }
        };
      })
    );
  }

  private getLoanDetails(loanId?: number) {
    if (loanId) {
      this.loanId = loanId;
    }
    const seq = this.loanApiService.getLoanDetails(this.loanId).pipe(
      map((loan) => {
        this.loans.next(loan);
        this.loanApiService.creatingLoan = false;
        return loan;
      })
    );
    return seq;
  }

  /*
   * This method is used only if any gaurd is called before this resolver else data will be available in the Activated Route.
   * */
  public getLoan(loanId: number) {
    if (this.loans.getValue() && loanId === this.loanId) {
      return of(this.loans.getValue());
    } else {
      return this.getLoanDetails(loanId);
    }
  }
}
